export default function getPermissionsWithRoles(listesRoles) {
  const allPermisions = [];
  listesRoles.forEach((role) => {
    role.grantedPermissions.forEach((permission) => {
      if (!allPermisions.includes(permission)) allPermisions.push(permission);
    });
  });
  return allPermisions;
}
